/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsTotalActiveNodesCount } from "../../funcs/metricsGetApiV3MetricsTotalActiveNodesCount.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3MetricsTotalActiveNodesCountRequest$inboundSchema
    .optional(),
};

export const tool$metricsGetApiV3MetricsTotalActiveNodesCount: ToolDefinition<
  typeof args
> = {
  name: "metrics-get-api-v3-metrics-total-active-nodes-count",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await metricsGetApiV3MetricsTotalActiveNodesCount(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
